import { NotificationEventItem } from './NotificationEventItem'
import { DesignSubmittalStatus } from '../statuses/deprecated'
import {
  AllApprovalsNotificationEventItem,
  PartialApprovalNotificationEventItem,
} from './common/approval'
import { CommentedNotificationEventItem } from './common/commented'
import { DispositionGivenNotificationEventItem } from './common/disposition'
import { EditedNotificationEventItem } from './common/edited'
import { NumberNameEditedNotificationEventItem } from './common/numberName'
import { RevertedNotificationEventItem } from './common/reverted'
import { NotificationEventEnum } from '.'

const ds = 'Design Submittal' as const

const Submitted = new NotificationEventItem({
  id: '6DC112D8-8DD7-4A6A-9209-D89020D8D485',
  name: 'Submitted',
  description: `A new ${ds} is submitted for the workflow`,
})
const RoutedToDisciplineAction = new NotificationEventItem({
  id: 'CDE56505-B32F-42D2-BE19-CBCF342E3D66',
  name: 'Route to Discipline Action',
  description: `A router determines the ${ds} is ready for ${DesignSubmittalStatus.DisciplineAction}`,
})
const DisciplineReviewAccepted = PartialApprovalNotificationEventItem({
  id: '1345C77C-1CD6-4BA7-B9D4-F2F91E2FB467',
  name: 'Discipline Review Accepted',
  description: { object: ds, group: 'Discipline' },
})
const AllDisciplineReviewsAccepted = AllApprovalsNotificationEventItem({
  id: '2BD6AAD6-A93E-4B3B-B363-B4167585C5AB',
  name: 'All Discipline Reviews Accepted',
  description: { object: ds, group: 'Discipline' },
})
const ReturnedToDesign = DispositionGivenNotificationEventItem({
  id: 'EE095888-C03B-4253-A023-443375EB830F',
  name: 'Returned to Design',
  submittal: ds,
})
const Reverted = RevertedNotificationEventItem({
  id: '308DDD1C-AE14-428E-A5B3-443BCE057B31',
  revertable: ds,
  from: 'Returned to Design Builder',
  to: 'Discipline Action',
})
const NumberOrNameEdited = NumberNameEditedNotificationEventItem({
  id: '4850D8AF-312D-4C65-BA8C-0388861552C8',
})
const Edited = EditedNotificationEventItem({
  id: '49DE599C-E86F-4ECA-B8C6-D8F75D437BF5',
  editable: ds,
})
const Commented = CommentedNotificationEventItem({
  id: 'BF5C91A6-C063-4FE2-84B5-9B88982EDC42',
  commentable: ds,
})

export type DSNotificationEventItem =
  | typeof Submitted
  | typeof RoutedToDisciplineAction
  | typeof DisciplineReviewAccepted
  | typeof AllDisciplineReviewsAccepted
  | typeof ReturnedToDesign
  | typeof Reverted
  | typeof NumberOrNameEdited
  | typeof Edited
  | typeof Commented

class DSNotificationEventEnum extends NotificationEventEnum<
  'DSNotification',
  DSNotificationEventItem,
  DSNotificationEventItem['name'],
  DSNotificationEventItem['id']
> {
  readonly typename = 'DSNotification'
  get values() {
    return [
      this.Submitted,
      this.RoutedToDisciplineAction,
      this.DisciplineReviewAccepted,
      this.AllDisciplineReviewsAccepted,
      this.ReturnedToDesign,
      this.Reverted,
      this.NumberOrNameEdited,
      this.Edited,
      this.Commented,
    ]
  }
  readonly Submitted = Submitted
  readonly RoutedToDisciplineAction = RoutedToDisciplineAction
  readonly DisciplineReviewAccepted = DisciplineReviewAccepted
  readonly AllDisciplineReviewsAccepted = AllDisciplineReviewsAccepted
  readonly ReturnedToDesign = ReturnedToDesign
  readonly Reverted = Reverted
  readonly NumberOrNameEdited = NumberOrNameEdited
  readonly Edited = Edited
  readonly Commented = Commented
}

export const DSNotificationEvent = new DSNotificationEventEnum()
